import { autoinject, LogManager } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { EntityManager } from 'aurelia-orm';
import { DialogService } from 'aurelia-dialog';
import { ValidationController } from 'aurelia-validation';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { BootstrapFormRenderer } from 'core/bootstrap-form-renderer';
import { AppEvents } from 'core/app-events';
import { Item, Comment } from 'data/entities/entities';
import { ItemRepository } from 'data/repository/item-repository';
import { EntityStatuses, ItemStatuses } from 'core/enums';
import { SupportTicketService } from 'data/service/support-ticket-service';
import { CommentService } from 'data/service/comment-service';

@autoinject
export class ViewTicket {
    ticket: Item;
	eventSubscriptions: Array<Subscription> = [];
	newComment: Comment;
	item: Item;
    isAddingNewComment: boolean;
	
	constructor(
		private entityManager: EntityManager,
		private dialogService: DialogService,
		private validationController: ValidationController,
		private commentService: CommentService,
		private eventAggregator: EventAggregator,
		private router: Router,
		private supportTicketService:SupportTicketService,
		private bootstrapFormRenderer: BootstrapFormRenderer) {
		this.itemRepository = this.entityManager.getRepository(Item);
		this.validationController.addRenderer(bootstrapFormRenderer);
		this.commentService = commentService;
	}

	private unsubscribeFromEvents() {
		for (const entry of this.eventSubscriptions) {
			entry.dispose();
		}
		this.eventSubscriptions = [];
	}

	onDirectoryChanged(payload) {
		this.item = null;
	}

	subscribeToEvents() {
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.DIRECTORY_CHANGED, payload => {
			this.onDirectoryChanged(payload);
		}));
	}

	activate(params) {
		this.subscribeToEvents();
		this.initialize(params.id);
		this.logger.info("Viewing ID:" + params.id);		
	}

	initializeCommentEntity() {
		this.newComment = this.commentService.getNew();
	}

	deactivate() {
		this.unsubscribeFromEvents();
	}

	async closeTicket() {
		this.item.itemStatusId = ItemStatuses.Closed;
		this.item.closeDate = new Date();
		try {
			await this.supportTicketService.closeTicket(this.item.id);
			this.router.navigateToRoute('support');
		}
		catch (error) { this.logger.error(error); }
	}

	async cancel() {
		this.router.navigateToRoute('support');
	}

	async saveNewComment() {
		this.isAddingNewComment = false;
		if (this.newComment.content.trim() === '') return;
		this.newComment.createdDate = new Date();
		this.newComment.entityStatusId = EntityStatuses.Active;
		this.newComment.itemId = this.item.id;
		// this.item.comments._add(this.newComment);

		try {
			const result = await this.newComment.save();
			this.item.comments._add(result);
			this.logger.info("new comment saved");
			this.initializeCommentEntity();			
		}
		catch (error) {
			this.logger.error(error);
		}
	}

	cancelNewComment() {
		this.isAddingNewComment = false;		
	}

	addNewComment() {
		this.isAddingNewComment = true;
	}

	async initialize(id: number) {
		this.initializeCommentEntity();
		//Get Ticket
		try {
			this.item = await this.supportTicketService.getTicket(id);
		}
		catch (error) {
			console.log(error);
		}
	}

	className = "ViewTicketViewModel";
	itemRepository: ItemRepository;
	logger = LogManager.getLogger(this.className);	
}